import {
  concretiseParams,
  updateSearchParamsWithFilters,
} from "../filters/filters"
import { updateSearchParamsWithPagination } from "../../page"
import { API_BASE_URL } from "../../app/config"
import { getToken, handleSignIn } from "../iam/middleware"

/**
 * Get data submission
 * Data submissions are groupings of samples sent to a particular source
 * @param filers  // filters to apply
 * @param page  // pagination settings
 * @returns {Promise<any>}
 */
export const getDataSubmissions = async ({ filter = {}, page = {} }) => {
  // Build parameter set
  const params = new URLSearchParams()
  // Add the relevant filters
  updateSearchParamsWithFilters(params, filter)
  // Replace any relative ones with absolute ones
  concretiseParams(params)
  // Pagination control
  updateSearchParamsWithPagination(params, page)

  let resp = await fetch(
    `${API_BASE_URL}/api/data-submissions?${params.toString()}`,
    {
      method: "GET",
      mode: "cors",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      redirect: "error",
    }
  )
  resp = handleSignIn(resp)
  return resp.json()
}

/**
 * Get a data submission by Id
 * @param submissionId
 * @returns {Promise<any>}
 */
export const getSubmissionById = async (submissionId) => {
  let resp = await fetch(
    `${API_BASE_URL}/api/data-submissions/${submissionId}`,
    {
      method: "GET",
      mode: "cors",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      redirect: "error",
    }
  )

  resp = handleSignIn(resp)
  return resp.json()
}

/**
 * Generate samples and submit data to the UDL
 * Samples are data points at a particular time in the observation, typically ra, dec and timestamp
 * Data submissions are a collections of these samples sent to a particular destination e.g. the UDL
 * @param observationId
 * @returns {Promise<any>}
 */
export const generateSamplesForObservationAndSubmitToUDL = async ({
  observationId,
}) => {
  let resp = await fetch(
    `${API_BASE_URL}/api/data-submissions/observation/${observationId}/udl`,
    {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      redirect: "error",
    }
  )

  resp = handleSignIn(resp)
  return resp.json()
}
